var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#F1F1F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.987 12.4795C20.987 11.0561 19.8322 9.90234 18.4089 9.90234C16.9857 9.90257 15.8317 11.0562 15.8317 12.4795V13.1016H20.987V12.4795ZM20.987 16.5205V14.9023H15.8317V16.7295C15.8316 17.2263 15.4291 17.6287 14.9323 17.6289C14.4353 17.6289 14.032 17.2264 14.0319 16.7295V14.9062C13.1173 14.9528 12.3323 15.5879 12.1042 16.4834L10.5758 22.4834C10.2376 23.8111 11.2409 25.1016 12.611 25.1016H23.7477C25.1481 25.1015 26.156 23.7572 25.7633 22.4131L24.0085 16.4121C23.8248 15.7845 23.366 15.2953 22.7868 15.0586V16.5205C22.7867 17.0175 22.3834 17.4199 21.8864 17.4199C21.3894 17.4198 20.987 17.0175 20.987 16.5205ZM22.7868 13.1865C24.1762 13.4752 25.3258 14.5046 25.736 15.9072L27.4909 21.9072C28.2209 24.4037 26.3487 26.9022 23.7477 26.9023H12.611C10.0665 26.9023 8.20347 24.5048 8.83171 22.0391L10.36 16.0391C10.7914 14.346 12.2941 13.1529 14.0319 13.1055V12.4795C14.0319 10.0621 15.9915 8.10179 18.4089 8.10156C20.8264 8.10156 22.7868 10.062 22.7868 12.4795V13.1865Z",
    fill: "#3F3F3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/bag.95d56e0a92a222e65c6494247709f831.svg";
export { ForwardRef as ReactComponent };